

import img1 from '../images/product/product2.jpg'
import img2 from '../images/product/product32.jpg'
import img3 from '../images/product/product33.jpg'
import img4 from '../images/product/product34.jpg'
import img5 from '../images/product/product35.jpg'
import img6 from '../images/product/product36.jpg'
import img7 from '../images/product/product37.jpg'
import img8 from '../images/product/product38.jpg'
import img9 from '../images/product/product39.jpg'
import img10 from '../images/product/product40.jpg'
import img11 from '../images/product/product41.jpg'
import img12 from '../images/product/product42.jpg'
import avt from '../images/author/author1.png'

// D.T Wallet Voucher Data
const dataHotpick = [
    {
        id: 1,
        img: img1,
        avt: avt,
        title: 'Flipkart ',
        create: 'E-Gift Card',
        price : '₹500'
    },
    {
        id: 2,
        img: img2,
        avt: avt,
        title: 'Amazon',
        create: 'E-Gift Card',
        price : '₹250'
    },
    {
        id: 3,
        img: img3,
        avt: avt,
        title: 'BGMI UNPI',
        create: 'E-Gift Card',
        price : '₹1000'
    },
    {
        id: 4,
        img: img4,
        avt: avt,
        title: 'iTunes',
        create: 'E-Gift Card',
        price : '₹2000'
    },
    {
        id: 5,
        img: img5,
        avt: avt,
        title: 'iTunes',
        create: 'E-Gift Card',
        price : '₹750'
    },
    {
        id: 6,
        img: img6,
        avt: avt,
        title: 'iTunes',
        create: 'E-Gift Card',
        price : '₹1500'
    },

    {
        id: 7,
        img: img7,
        avt: avt,
        title: 'Myntra',
        create: 'E-Gift Card',
        price : '₹600'
    },
    {
        id: 8,
        img: img8,
        avt: avt,
        title: 'Swiggy',
        create: 'E-Gift Card',
        price : '₹400'
    },

    {
        id: 9,
        img: img9,
        avt: avt,
        title: 'Myntra',
        create: 'E-Gift Card',
        price : '₹300'
    },
    {
        id: 10,
        img: img10,
        avt: avt,
        title: 'Swiggy',
        create: 'E-Gift Card',
        price : '₹450'
    },
    {
        id: 11,
        img: img11,
        avt: avt,
        title: 'Swiggy',
        create: 'E-Gift Card',
        price : '₹800'
    },
    {
        id: 12,
        img: img12,
        avt: avt,
        title: 'Myntra',
        create: 'E-Gift Card',
        price : '₹350'
    },
]

export default dataHotpick;